import angular from "angular";
//import routes from "./routes.js";

import LogService from "./LogService";
import LogDecorator from "./LogDecorator";

export default angular.module("modules.logging", [])
    .config(LogDecorator)
    .service("LogService", LogService)
    .provider("$exceptionHandler", {
        $get: ["LogService","$log",function(LogService,$log){
          return function myExceptionHandler(exception, cause) {
                $log.error(exception, cause);
          };
        }]
      })
    .name;



// WEBPACK FOOTER //
// ./src/ui/modules/logging/index.js